let LotTreatmentBanner = (props) => {  
  let lot = props.lot;	
  if (!lot) return null; // Added guard clause

  let optIn  = [
	['1405', '//nike.com'],
    ['1425', '//nike.com'],
  ];

  let prefix = lot.substring(0, 4);
  let tTxt  = props.tr;      
  let value = -1; //prevents undefined or null

  if (typeof tTxt !== 'undefined' && typeof tTxt === 'string') {
    switch(tTxt.toLowerCase()){    
    case "expedry":  
    optIn.some(subArray => {
        if (subArray.includes(prefix)) {
          //console.log('optIn:ExternalURL')
          value = subArray[1];
          return true; // Exit the loop early
        }else{
          value = undefined;      
        }
    });      
    break; 

    default:
    break;    
    }    
  }

  if(value === undefined){  
	return(<div className="il__banner"><a href={`//alliedfeather.com/innovation/expedry?ref=tmd-com&lot=${lot}`} target="_blank"></a></div>);	  	  
  }else if (value !== -1) {	
	return(<div className="il__banner"><a href={`${value}?ref=tmd-com&lot=${lot}`} target="_blank"></a></div>);  
  }else{
	//console.log(`"${target}" not found in the optIn.`);
	return(<div className="il__banner"></div>);
  }
} 

export { LotTreatmentBanner }